import {createSlice} from '@reduxjs/toolkit';

import {reducerPrepareSurvey} from './actions/prepareSurvey';
import {initialState, namespace} from './constants';

const survey = createSlice({
    name: namespace,
    initialState,
    reducers: {
        prepareSurvey: reducerPrepareSurvey,
    },
});

export default survey;
